/** 
 * Returns the stored time value in seconds since midnight, January 1, 1970 UTC.
 * 
 * @param date The date to convert to seconds.
 * @return The time in seconds.
 */
export const getTimeInSeconds = (date?: Date, setDateToEnd?: boolean) => {
    if (!date) return date;

    const timeInMillis = setDateToEnd ? new Date(date).setHours(23, 59, 59) :  new Date(date).getTime();
    return Math.round(timeInMillis / 1000);
}